import { Location } from 'history'
import history from '../../routing/history'
import { getLinkName } from '../../routing/links'
import { getMetrics } from '../metrics'

function routeChange(location: Location, previousLocation: string) {
  try {
    const metrics = getMetrics()
    // metrics.setRouteState(location);
    metrics.api.pageView({
      location: window.location.origin + location.pathname,
      previousLocation,
    })
  } catch (e) {
    console.error(`Metrics failed becase: ${e}`)
  }
}

export function updateLocation(location: Location) {
  if (location.pathname !== prevLocation.pathname) {
    const fullPrevPathname = window.location.origin + prevLocation.pathname
    routeChange(
      location,
      prevLocation.pathname !== undefined ? fullPrevPathname : prevLocation,
    )
    prevLocation = location
  }
}

let prevLocation: any = document.referrer
export function initialisePageTracking() {
  history.listen((location: Location) => {
    updateLocation(location)
  })
  updateLocation(history.location)
}
